// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1rlst","colMaxWidth":"Table_colMaxWidth__1QdyK"};